import { MEETING_TYPE } from '@src/constants';

export const TYPE_FILTER_OPTIONS = [
  { label: 'All', value: 'all' },
  { label: 'Webinars only', value: MEETING_TYPE.WEBINAR },
  { label: 'Meetings only', value: MEETING_TYPE.MEETING },
];

export const DATE_OPTIONS = {
  weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: 'numeric',
} as const;

export const DATE_BANNER_OPTIONS = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
} as const;

export type TDateOptions = typeof DATE_OPTIONS;
